import {CONTACTS_URL} from "../constants/api";
import {SENIORS_CHECKBOX, SENIORS_FETCH} from "../constants/actionTypes";
import {getStorageImageUrl} from "../../../shared/actions";
import seniorsImage from '../../../../assets/img/seniors_211x211.png';
import {RC_USER_PREFIX_T} from "../../../shared/modules/rocketChat/constants";
import {NO_IMAGE, TYPE_SENIOR} from "../constants";
import {
  MODE_B2B_COMMUNICATION,
  MODE_B2C_FULL_FEATURE
} from "../../user/constants";
import {USER_SET_MODE} from "../../user/constants/actionTypes";
import {requestAuth} from "../../../request";

/**
 * Gets senior by it`s identification
 * @param {string} id - senior identification
 * @returns {function(dispatch, getState)} thunk to be dispatched
 */
export function getSenior(id) {
  return (dispatch, getState) => {
    return getState().seniors.find((senior) => {
      return senior.prof_id.toString() === id;
    })
  };
}

/**
 * Member seniors fetched action
 * @param {array} seniors - fetched seniors
 * @returns {{type: string, payload: Array}} member fetch seniors action
 */
export function fetchAction(seniors) {
  return {
    type: SENIORS_FETCH,
    payload: seniors.map((senior, seniorIndex) => {
      return {
        id: seniorIndex + 1,
        key: seniorIndex + 1,
        prof_id: senior.p_prof_id,
        type: TYPE_SENIOR,
        firstname: senior.p_firstname,
        lastname: senior.p_lastname,
        username: RC_USER_PREFIX_T + senior.p_prof_id,
        checkbox: senior.status,
        device_id: senior.p_device_id,
        imgUrl: senior.p_prof_img === NO_IMAGE
          ? seniorsImage
          : getStorageImageUrl(senior.p_prof_img)
      }
    })
  };
}

/**
 * Gets list of seniors
 * @returns {function(dispatch, getState): Promise<any>} promised thunk to be dispatched
 */
export function getSeniors() {
  return (dispatch) =>
    requestAuth()
      .post(CONTACTS_URL)
      .type("application/json")
      .send({})
      .then((res) => dispatch(fetchAction(res.body)).payload)
}

/**
 * Change senior checkbox state
 * @param {boolean} state - is checked or not
 * @param {int} deviceId - device identification
 * @param {int} profId - profile identification
 * @returns {function(dispatch)} thunk to be dispatched
 */
export function changeCheckbox(state, deviceId, profId) {
  return (dispatch) => {
    return Promise.resolve(
        dispatch(
          {
           type: SENIORS_CHECKBOX,
           payload: {
             state: state,
             profId: profId,
             deviceId: deviceId
           }
          }
        )
      );
  };
}

/**
 * Check user mode by senior list
 * @param {array} seniors - senior list
 * @returns {function(dispatch)} thunk to be dispatched
 */
export function checkUserMode(seniors) {
  const b2b_seniors = [
    24758123,
    24758124,
    30560395,
    30560396
  ];
  const isB2B = seniors.some((senior) => b2b_seniors.includes(senior.prof_id));

  return (dispatch) => dispatch({
    type: USER_SET_MODE,
    payload: isB2B ? MODE_B2B_COMMUNICATION : MODE_B2C_FULL_FEATURE
  });
}
